<template>
    <Link
        v-if="item.route"
        :href="route(item.route, item.params)"

        class="navlink"
        :class="isSelected(item) ? 'bg-stone-300 dark:bg-slate-800': ''"
    >
        <font-awesome-icon :icon="item.icon" class="text-stone-700 dark:text-slate-300" />
        <span class="flex flex-wrap text-stone-900 dark:text-slate-100">{{ item.label }}</span>
    </Link>
    <Menu v-else-if="item.submenus" v-slot="{ open }">
        <MenuButton
            class="navlink w-full flex justify-between"
            :class="(open? 'bg-stone-300 dark:bg-slate-500': '') + (isSelected(item) ? 'bg-stone-300 dark:bg-slate-500': '')">
            <div class="flex flex-row space-x-1 items-center">
                <font-awesome-icon :icon="item.icon" class="text-stone-700 dark:text-slate-300" />
                <span class="flex flex-wrap text-stone-900 dark:text-slate-100">{{ item.label }}</span>
            </div>
            <font-awesome-icon class="text-stone-400 dark:text-slate-400"  :icon="open? 'chevron-up' : 'chevron-down'" />
        </MenuButton>
        <MenuItems class="w-full bg-custom">
            <MenuItem v-for="sub in item.submenus" :key="sub" as="div" class="pl-4">
                <CustomNavLink :item="sub" :selected="selected"></CustomNavLink>
            </MenuItem>
        </MenuItems>
    </Menu>
</template>

<script >
    export default {
        name: 'CustomNavLink'
    }
</script>

<script setup>
import { Link } from "@inertiajs/vue3";
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import CustomNavLink from './CustomNavLink.vue'
const props = defineProps({
    item: {
        type: Object,
        default: null,
    },
    selected: {
        type: Object,
        default: null,
    }
})

function isSelected(menu) {
    return menu === props.selected?.value??'';
}

</script>

<style scoped>
.navlink {
    @apply flex items-center p-2 space-x-2 text-sm uppercase transition-colors duration-150 border-2 border-transparent cursor-pointer text-stone-800 dark:text-gray-100 hover:text-stone-600 hover:bg-stone-200 dark:hover:bg-slate-700
}

.bg-custom {
    background-color: rgb(225, 223, 222)
}

.dark .bg-custom {
    background-color: rgb(60, 69, 86)
}
</style>
